module.exports = __webpack_public_path__ + "img/about-icon_2.9dd46f87.png";